// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * General Page Background
 */
body,
.exam-details-container {
  background: #f8fafc;
  min-height: 100vh;
  padding-top: 80px;
  padding-bottom: 80px;
}

.exam-details-col {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 32px 32px;
  margin-bottom: 32px;
  margin-top: 0;
  transition: box-shadow 0.2s;
}

.exam-details-col:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.04);
}

.exam-details-header-row {
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 18px;
}

.exam-details-header-row h6 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a365d;
  margin-bottom: 0;
}

.start-test-btn {
  min-width: 140px;
  font-size: 1rem;
  font-weight: 600;
  background: green;
  border: none;
  border-radius: 8px;
  color: #fff;
}

.exam-details-section-list {
  margin-bottom: 28px;
  background: transparent;
  border-radius: 10px;
  overflow-x: auto;
  white-space: normal;
}

.exam-details-section-list .list-group-item {
  border: none;
  border-radius: 10px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(26, 54, 93, 0.06);
  background: #f6fafd;
  transition: box-shadow 0.2s;
}

.exam-details-section-list .list-group-item:hover {
  box-shadow: 0 4px 12px rgba(26, 54, 93, 0.1);
  background: #e6edf8;
}

.card.mt-4 {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(26, 54, 93, 0.06);
  background: #f8fafc;
}

.card-body > div:first-child {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a365d;
  margin-bottom: 8px;
}

.exam-details-header,
.exam-details-footer {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
  background: #e6edf8;
  box-shadow: 0 2px 8px rgba(26, 54, 93, 0.04);
}

.exam-details-header {
  top: 0;
  padding: 0 0 0px 0;
}

.exam-details-footer {
  bottom: 0;
  height: 60px;
  display: flex;
  align-items: start;
  justify-content: center;
}

@media (max-width: 1024px) and (min-width: 768px) {
  .exam-details-container {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .exam-details-col {
    padding: 20px 12px;
    margin-bottom: 20px;
  }
  .exam-details-header-row {
    gap: 10px;
  }
  .start-test-btn {
    width: 100%;
    margin-top: 8px;
    font-size: 1rem;
  }
}
@media (max-width: 767px) {
  .exam-details-container {
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .exam-details-col {
    padding: 10px 4px;
    margin-bottom: 12px;
    border-radius: 8px;
  }
  .exam-details-header-row h6 {
    font-size: 1.08rem;
  }
  .start-test-btn {
    min-width: 100px;
    font-size: 0.98rem;
    padding: 10px 0;
  }
  .exam-details-section-list .list-group-item {
    font-size: 0.98rem;
    padding: 12px 8px;
  }
}
@media (max-width: 500px) {
  .exam-details-container {
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .exam-details-col {
    padding: 4px 0;
  }
  .exam-details-header-row {
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/exams/examDetails.scss"],"names":[],"mappings":"AAAA;;EAAA;AAIA;;EAEE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;AAAF;;AAEA;EACE,yEAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,mBAAA;AACF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAEF;;AACA;EACE,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,2BAAA;AACF;;AACA;EACE,4CAAA;EACA,mBAAA;AAEF;;AAEA;EACE,mBAAA;EACA,4CAAA;EACA,mBAAA;AACF;;AACA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAEF;;AAEA;;EAEE,eAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,4CAAA;AACF;;AACA;EACE,MAAA;EACA,kBAAA;AAEF;;AAAA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;AAGF;;AACA;EACE;IACE,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,oBAAA;EAEF;EAAA;IACE,kBAAA;IACA,mBAAA;EAEF;EAAA;IACE,SAAA;EAEF;EAAA;IACE,WAAA;IACA,eAAA;IACA,eAAA;EAEF;AACF;AAAA;EACE;IACE,iBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;EAEF;EAAA;IACE,iBAAA;IACA,mBAAA;IACA,kBAAA;EAEF;EAAA;IACE,kBAAA;EAEF;EAAA;IACE,gBAAA;IACA,kBAAA;IACA,eAAA;EAEF;EAAA;IACE,kBAAA;IACA,iBAAA;EAEF;AACF;AAAA;EACE;IACE,iBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;EAEF;EAAA;IACE,cAAA;EAEF;EAAA;IACE,QAAA;EAEF;AACF","sourcesContent":["/**\n * General Page Background\n */\n// Consistent clean background\nbody,\n.exam-details-container {\n  background: #f8fafc;\n  min-height: 100vh;\n  padding-top: 80px;\n  padding-bottom: 80px;\n}\n\n.exam-details-col {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  padding: 32px 32px;\n  margin-bottom: 32px;\n  margin-top: 0;\n  transition: box-shadow 0.2s;\n}\n.exam-details-col:hover {\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.exam-details-header-row {\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n.exam-details-header-row h6 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1a365d;\n  margin-bottom: 0;\n}\n\n.start-test-btn {\n  min-width: 140px;\n  font-size: 1rem;\n  font-weight: 600;\n  background: green;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n}\n\n.exam-details-section-list {\n  margin-bottom: 28px;\n  background: transparent;\n  border-radius: 10px;\n  overflow-x: auto;\n  white-space: normal;\n}\n\n// ListGroup.Item (override)\n.exam-details-section-list .list-group-item {\n  border: none;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  box-shadow: 0 1px 4px rgba(26, 54, 93, 0.06);\n  background: #f6fafd;\n  transition: box-shadow 0.2s;\n}\n.exam-details-section-list .list-group-item:hover {\n  box-shadow: 0 4px 12px rgba(26, 54, 93, 0.1);\n  background: #e6edf8;\n}\n\n// Instructions Card\n.card.mt-4 {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(26, 54, 93, 0.06);\n  background: #f8fafc;\n}\n.card-body > div:first-child {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1a365d;\n  margin-bottom: 8px;\n}\n\n// Header/Footer\n.exam-details-header,\n.exam-details-footer {\n  position: fixed;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background: #e6edf8;\n  box-shadow: 0 2px 8px rgba(26, 54, 93, 0.04);\n}\n.exam-details-header {\n  top: 0;\n  padding: 0 0 0px 0;\n}\n.exam-details-footer {\n  bottom: 0;\n  height: 60px;\n  display: flex;\n  align-items: start;\n  justify-content: center;\n}\n\n// Responsive Typography & Spacing\n@media (max-width: 1024px) and (min-width: 768px) {\n  .exam-details-container {\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-top: 70px;\n    padding-bottom: 70px;\n  }\n  .exam-details-col {\n    padding: 20px 12px;\n    margin-bottom: 20px;\n  }\n  .exam-details-header-row {\n    gap: 10px;\n  }\n  .start-test-btn {\n    width: 100%;\n    margin-top: 8px;\n    font-size: 1rem;\n  }\n}\n@media (max-width: 767px) {\n  .exam-details-container {\n    padding-left: 8px;\n    padding-right: 8px;\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n  .exam-details-col {\n    padding: 10px 4px;\n    margin-bottom: 12px;\n    border-radius: 8px;\n  }\n  .exam-details-header-row h6 {\n    font-size: 1.08rem;\n  }\n  .start-test-btn {\n    min-width: 100px;\n    font-size: 0.98rem;\n    padding: 10px 0;\n  }\n  .exam-details-section-list .list-group-item {\n    font-size: 0.98rem;\n    padding: 12px 8px;\n  }\n}\n@media (max-width: 500px) {\n  .exam-details-container {\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n  .exam-details-col {\n    padding: 4px 0;\n  }\n  .exam-details-header-row {\n    gap: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
